import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { DamagedMaterialsPage } from "@/modules/material/pages/DamagedMaterials.page";

export const Route = createFileRoute("/__authed/m/materials/damaged")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_materials")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: DamagedMaterialsPage,
});
